import Login from './pages/Login.js';
import Dashboard from './pages/Dashboard.js';
import Empresas from './pages/Empresas.js';
import Usuarios from './pages/Usuarios.js';
import Pacientes from './pages/Pacientes.js';
import MobiLight from './pages/MobiLight.js';
import Terapias from './pages/Terapias.js';
import RecuperarSenha from './pages/RecuperarSenha.js';
import ChangePassword from './pages/ChangePassword.js';
import Suporte from './pages/Suporte.js';
import TermoDeUso from './pages/TermoDeUso.js';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade.js';

// 🔧 Função de verificação
function checkAuth() {
  const token = localStorage.getItem('token');
  if (!token) {
    window.location.hash = '#/login';
    return false;
  }
  return true;
}

function checkUserFinal() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  return usuario && usuario.descricao === 'Usuario Final';
}

// Função principal de roteamento
function router() {
  const hash = window.location.hash || '#/login';
  const app = document.getElementById('app');
  const sidebar = document.querySelector('.sidebar');
  const body = document.body;

  if (!app) {
    console.error('Elemento #app não encontrado no DOM.');  
    return;
  }

  console.log('Rota atual:', hash);

  app.innerHTML = ''; // limpa o conteúdo antes de renderizar

  body.classList.remove('hide-sidebar');
  sidebar.style.display = '';

  switch (hash) {
    case '#/login':
      app.appendChild(Login());
      break;

    case '#/dashboard':
      if (!checkAuth()) return;
      app.appendChild(Dashboard());
      break;

    case '#/empresas':
      if (!checkAuth()) return;
      if (!checkUserFinal()) {
        app.innerHTML = '<h2>Acesso negado</h2>';
        return;
      }
      app.appendChild(Empresas());
      break;

    case '#/usuarios':
      if (!checkAuth()) return;
      app.appendChild(Usuarios());
      break;

    case '#/pacientes':
      if (!checkAuth()) return;
      app.appendChild(Pacientes());
      break;

     case '#/mobilight':
      if (!checkAuth()) return;
      if (!checkUserFinal()) {
        app.innerHTML = '<h2>Acesso negado</h2>';
        return;
      }
      app.appendChild(MobiLight());
      break;

    case '#/terapias':
      if (!checkAuth()) return;
      app.appendChild(Terapias());
      break;

    case '#/recuperarsenha':
      body.classList.add('hide-sidebar');
      sidebar.style.display = 'none';
      app.appendChild(RecuperarSenha());
      break;

    case '#/suporte':
      body.classList.add('hide-sidebar');
      sidebar.style.display = 'none';
      app.appendChild(Suporte());
      break;

    case '#/termodeuso':
      body.classList.add('hide-sidebar');
      sidebar.style.display = 'none';
      app.appendChild(TermoDeUso());
      break;

    case '#/politicaprivacidade':
      body.classList.add('hide-sidebar');
      sidebar.style.display = 'none';
      app.appendChild(PoliticaPrivacidade());
      break;
    default:
      app.innerHTML = '<h2>Página não encontrada</h2>';
  }
}

// Escuta mudanças na hash da URL
window.addEventListener('hashchange', router);

// Executa o roteador ao carregar a página
window.addEventListener('load', router);

window.ChangePassword = ChangePassword;
